import { FormType } from '../../../form-types';
import { ZaludPinkEyeQuestionFieldAnswers } from './questions';

const pinkEye: FormType<ZaludPinkEyeQuestionFieldAnswers> = {
  name: 'Pink Eye Intake',
  questions: [
    {
      key: 'zalud_pinkEye_redFlagSymptoms',
      next: {
        condition: { 'zalud_pinkEye_redFlagSymptoms.none': true },
        key: 'zalud_pinkEye_fever',
        els: 'zalud_pinkEye_ineligible'
      }
    },
    'zalud_pinkEye_fever',
    'zalud_pinkEye_eyesAffected',
    'zalud_pinkEye_symptoms',
    'zalud_pinkEye_visionChanges',
    {
      key: 'zalud_pinkEye_contactLensHistory',
      next: {
        condition: {
          'zalud_pinkEye_contactLensHistory.wore_within_7_days': true
        },
        key: 'zalud_pinkEye_ineligible',
        els: 'zalud_pinkEye_seasonalAllergies'
      }
    },
    'zalud_pinkEye_seasonalAllergies',
    'zalud_pinkEye_additionalComments',
    {
      key: 'zalud_pinkEye_consent',
      next: {
        condition: { 'zalud_pinkEye_consent.proceed': true },
        key: 'zalud_pinkEye_complete',
        els: 'zalud_pinkEye_ineligible'
      }
    },
    'zalud_pinkEye_complete',
    'zalud_pinkEye_ineligible'
  ]
};

export default pinkEye;
